import * as React from 'react';
import { SVGProps } from 'react';

const IconVolumeDownSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m7.944 8 4.16-3.663c.7-.72 1.896-.21 1.896.808v13.71c0 1.018-1.197 1.528-1.897.808L8 16H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2.944ZM18.42 7.57a1 1 0 1 0-1.548 1.266 5 5 0 0 1-.005 6.333 1 1 0 1 0 1.547 1.268 7 7 0 0 0 .006-8.866Z" />
  </svg>
);
export default IconVolumeDownSizeM;
